export * from "./rp_registration";

/**
 * @deprecated
 * @use useLeadSources instead
 */
export var leadSources = [{
  id: 1,
  value: 'applyboost',
  label: 'ApplyBoost'
}, {
  id: 2,
  value: 'applyboard_referral_link',
  label: 'ApplyBoard referral link'
}, {
  id: 3,
  value: 'walk_in',
  label: 'Walk in'
}, {
  id: 4,
  value: 'facebook',
  label: 'Facebook'
}, {
  id: 5,
  value: 'instagram',
  label: 'Instagram'
}, {
  id: 6,
  value: 'youtube',
  label: 'Youtube'
}, {
  id: 7,
  value: 'client',
  label: 'Client'
}, {
  id: 8,
  value: 'another_student',
  label: 'Another Student'
}, {
  id: 9,
  value: 'friend',
  label: 'Friend'
}, {
  id: 10,
  value: 'staff',
  label: 'Staff'
}, {
  id: 11,
  value: 'in_person_event',
  label: 'In-person event'
}, {
  id: 12,
  value: 'virtual_event',
  label: 'Virtual event'
}, {
  id: 13,
  value: 'immigration_agent',
  label: 'Immigration agent'
}, {
  id: 14,
  value: 'other',
  label: 'Other'
}];

/**
 * @deprecated
 * @use useLeadStatuses instead
 */
export var leadStatuses = [{
  value: 'new_lead',
  label: 'New Lead'
}, {
  value: 'follow_up',
  label: 'Follow up'
}, {
  value: 'ready_to_apply',
  label: 'Ready to Apply'
}];
export var StudentReferralTool = /*#__PURE__*/function (StudentReferralTool) {
  StudentReferralTool[StudentReferralTool["DirectStudentSignup"] = 1] = "DirectStudentSignup";
  StudentReferralTool[StudentReferralTool["AddNewStudentModal"] = 2] = "AddNewStudentModal";
  StudentReferralTool[StudentReferralTool["InviteStudentLink"] = 3] = "InviteStudentLink";
  StudentReferralTool[StudentReferralTool["EmbeddableSearch"] = 4] = "EmbeddableSearch";
  StudentReferralTool[StudentReferralTool["BulkImport"] = 5] = "BulkImport";
  StudentReferralTool[StudentReferralTool["StudentIntakeForm"] = 6] = "StudentIntakeForm";
  return StudentReferralTool;
}({});
export var PHONE_FORMAT_REGEX = /^\+?[0-9\s-]+$/;